import styled from 'styled-components';

export const DemandNumber = styled.span`
    font-variant-numeric: tabular-nums slashed-zero;
    font-feature-settings: 'tnum', 'zero', 'ss01';
`;
